import { Dimensions } from "react-native";

const { width: W } = Dimensions.get("window");

function mq(
  max_481: number | string,
  max_641 = max_481,
  min_961 = max_481
): number | string {
  return W < 481 ? max_481 : W < 641 ? max_641 : min_961;
}

export default mq;
